import React from 'react';
import { connect } from 'react-redux';
import config from 'config';
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import Typography from 'material-ui/Typography';
import Drawer from 'material-ui/Drawer';
import { isMobile } from 'react-device-detect';
import SvgIcon from 'material-ui/SvgIcon';
import Button from 'material-ui/Button';
import Icon from 'material-ui/Icon';
import MapView from '../components/MapView';
import RightView from '../components/RightView';
import IntroView from '../components/IntroView';
import CountryView from '../components/CountryView';
import ZoomControl from '../components/ZoomControl';

const cities = require('../../../cities.json');
const organizations = require('../../../organizations.json');
const countries = require('country-data').countries;

const SaveIcon = props => (
  <SvgIcon {...props}>
    <path d="M0 0h24v24H0z" fill="none" />
    <path d="M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z" />
  </SvgIcon>
);

export class Home extends React.PureComponent {
  constructor(props) {
    super(props);
    let totalFunding = 0;
    for (const org of organizations) {
      totalFunding += org.amount;
    }
    this.state = {
      organizations: [],
      organizations_by_country: [],
      totalFunding,
      country: '',
      flag: '',
      left: false,
      openIntro: isMobile,
      zoom: 1,
    };
    this.handleCloseClick = this.handleCloseClick.bind(this);
    this.scaleIn = this.scaleIn.bind(this);
    this.scaleOut = this.scaleOut.bind(this);
    this.animateFit = this.animateFit.bind(this);
  }
  getOrganizations(city) {
    const orgs = [];
    for (const org of organizations) {
      if (org.city_slug === city.toLowerCase()) {
        orgs.push(org);
      }
    }
    this.setState({
      organizations: orgs,
      left: true,
    });
    if (isMobile) {
      this.setState({
        organizations_by_country: [],
      });
    }
  }

  getOrganizationsByCountry(country) {
    const orgs = [];
    for (const org of organizations) {
      for (const item of cities) {
        if (item.slug === org.city_slug) {
          org.city = item.name;
        }
      }
      if (org.country.toLowerCase() === country.toLowerCase()) {
        orgs.push(org);
      }
    }
    this.setState({
      organizations_by_country: orgs,
      country: (countries[country]) ? countries[country].name : '',
      // flag: (countries[country]) ? 'http://www.geognos.com/api/en/countries/flag/' + country + '.png' : '',
      flag: (countries[country]) ? 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/2.9.0/flags/4x3/' + country.toLowerCase() + '.svg' : '',
      left: (orgs.length !== 0),
    });
    if (isMobile) {
      this.setState({
        organizations: [],
      });
    }
  }

  getRightView() {
    const output = [];
    const orgs = this.state.organizations;
    let key = new Date().getTime();
    let index = 0;
    if (this.state.organizations_by_country.length) {
      key = new Date().getTime() + index;
      output.push(<CountryView key={key} flag={this.state.flag} organizations={this.state.organizations_by_country} country={this.state.country} />);
      index++;
    }
    orgs.map(
      (org) => {
        key += index;
        index++;
        org.country = org.country.toUpperCase();
        const country = (countries[org.country]) ? countries[org.country].name : '';
        let city = '';
        for (const item of cities) {
          if (item.slug === org.city_slug) {
            city = item.name;
          }
        }
        output.push(<RightView key={key} organization={org} country={country} city={city} />);
      }
    );
    return (
      output
    );
  }

  saveDisk() {
    window.location.href = config.fileURL;
  }

  handleCloseClick() {
    this.setState({
      left: false,
    });
  }

  handleIntroClose() {
    this.setState({
      openIntro: false,
    });
  }

  scaleIn() {
    this.setState({
      zoom: this.state.zoom * 2,
    });
  }

  scaleOut() {
    if (this.state.zoom !== 1) {
      this.setState({
        zoom: this.state.zoom / 2,
      });
    }
  }

  animateFit() {
    this.setState({
      zoom: 1,
    });
  }

  render() {
    const scale = config.map_options.scale;
    const projectionConfig = config.map_options.projectionConfig;
    const zoomableGroup = config.map_options.zoomableGroup;
    const popScales = config.popScales;

    const topojson = '/topojson-maps/europe.topo.json';

    return (
      <div className="app-home">
        <AppBar position="static" style={{ backgroundColor: '#4C454C' }}>
          <Toolbar>
            <Typography type="title" color="inherit" className="app-title">
              {config.app_title}
            </Typography>
            <Button variant="raised" className="download-button" onClick={() => this.saveDisk()} >
              <SaveIcon className="left-icon" />
              Download
            </Button>
          </Toolbar>
        </AppBar>
        <div className="right-view">
          {
            ((this.state.organizations.length || this.state.organizations_by_country.length)) ?
              this.getRightView() :
              <IntroView totalFunding={this.state.totalFunding} />
          }
        </div>
        <MapView cities={cities} getDetail={(city) => this.getOrganizations(city)} getDetailByCountry={(country) => this.getOrganizationsByCountry(country)} organizations={organizations} scale={scale} popScales={popScales} topojson={topojson} projectionConfig={projectionConfig} zoomableGroup={zoomableGroup} zoom={this.state.zoom} />
        <div className="right-panel">
          <div className="zoom-panel">
            <ZoomControl handleInClick={this.scaleIn} handleOutClick={this.scaleOut} handleFitClick={this.animateFit} className="zoom-control" />
          </div>
        </div>
        <Drawer open={this.state.left} onClose={() => this.setState({ left: false })} className="left-drawer">
          <Icon color="action" onClick={this.handleCloseClick} className="close-icon">close</Icon>
          <div style={{ paddingLeft: 10, paddingRight: 10, paddingTop: 10 }}>{this.getRightView()}</div>
        </Drawer>
        <div className="copyright">
          An infographc by CounterJihad.com
        </div>
        <Drawer open={this.state.openIntro} onClose={() => this.setState({ openIntro: false })} className="intro-drawer">
          <IntroView totalFunding={this.state.totalFunding} />
          <Button color="primary" style={{ fontSize: '1.5em', marginBottom: 20, color: '#2196f3' }} onClick={() => this.setState({ openIntro: false })}>
            Next
          </Button>
          <br />
          <br />
          <br />
        </Drawer>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return { user: state.user };
}

export default connect(mapStateToProps)(Home);



// WEBPACK FOOTER //
// ./scripts/routes/Home.jsx